/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React from "react";
import { DatePicker } from "office-ui-fabric-react";
import { minDateValue, maxDateValue } from "../../../Constants/Time";
import FormikErrorMessage from "../FormikErrorMessage/FormikErrorMessage";
import { DayPickerStrings } from "../../../Constants/DateConstants";

/**
 * OfficeUI DatePicker Field for use in Formik Forms
 * @returns {React.ReactElement} formik datepicker compnent.
 */
const FormikDatePicker = (props: any): React.ReactElement => {
  const { field, form, styles } = props;
  const minDate: Date = props.startDate ? props.startDate : new Date(minDateValue);
  const maxDate: Date = props.endDate ? props.endDate : new Date(maxDateValue);

  return (
    <div>
      <DatePicker
        strings={DayPickerStrings}
        onSelectDate={props.onSelectDate}
        initialPickerDate={form.values[field.name]}
        label={props.label}
        value={field.value}
        placeholder="Select a Date"
        minDate={minDate}
        maxDate={maxDate}
        styles={styles}
        {...props}
        isRequired={props.required}
      />
      <FormikErrorMessage name={field.name} />
    </div>
  );
};
export default FormikDatePicker;
